module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/waku-waku-2-333a177de32878909a021f96c1260ca7.jpg";